<script lang="ts">
  import { fade } from "svelte/transition";
  import Spinner from "./Spinner.svelte";

  export let isActive: boolean;
</script>

{#if isActive}
  <div
    transition:fade
    class="absolute inset-0 z-10 bg-white/75 flex items-center justify-center"
  >
    <div class="text-4xl text-olli-500">
      <Spinner />
    </div>
  </div>
{/if}
